<nb-card
  [class.notification-list]="!isInDashboard"
  size="medium"
  style="min-width: 23rem; height: 31.5rem"
>
  <nb-card-header>
    <div class="row">
      <div class="col">
        <h6 translate="notification.title"></h6>
      </div>
      <div class="col">
        <span
          class="subtitle-2 highlight-text float-right mark-as-read"
          (click)="markAllAsRead()"
          translate="notification.markAllAsRead"
        ></span>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body>
    @if (notifications && notifications.length === 0) {
    <nb-alert
      translate="notification.noNotificationsAlert"
      status="basic"
      class="no-notification-banner"
    ></nb-alert>
    } @if (notifications) {
    <nb-list>
      @for (notification of notifications; track notification) {
      <nb-list-item
        class="notification"
        (click)="clickOnNotification(notification)"
      >
        <div class="row full-width">
          <div class="col-2 my-auto">
            @switch (notification.type) { @case
            (eNotificationType.TASK_RELEASED) {
            <span class="subtitle-2 has-custom-badge">
              <button nbButton status="basic">
                <nb-icon icon="file-text-outline"></nb-icon>
              </button>
              @if (!notification.read) {
              <div class="custom-badge"></div>
              }
            </span>
            } @case (eNotificationType.CHAPTER_RELEASED) {
            <span class="subtitle-2 has-custom-badge">
              <button nbButton status="basic">
                <nb-icon icon="book-open-outline"></nb-icon>
              </button>
              @if (!notification.read) {
              <div class="custom-badge"></div>
              }
            </span>
            } @case (eNotificationType.TEAM_INVITATION_RECEIVED) {
            <span class="subtitle-2 has-custom-badge">
              <nb-user
                shape="rectangle"
                [name]="
                  notificationService.toTeamInvitationReceivedNotification(
                    notification
                  ).creatorUser.fullName
                "
                [picture]="
                  notificationService.toTeamInvitationReceivedNotification(
                    notification
                  ).creatorUser.profilePicturePreviewUrl
                "
                onlyPicture
              ></nb-user>
              @if (!notification.read) {
              <span class="custom-badge user-badge"></span>
              }
            </span>
            } @case (eNotificationType.ADDED_TO_COURSE) {
            <span class="subtitle-2 has-custom-badge">
              <nb-user
                shape="rectangle"
                [name]="
                  notificationService.toAddedToCourseNotification(notification)
                    .creatorUser.fullName
                "
                [picture]="
                  notificationService.toAddedToCourseNotification(notification)
                    .creatorUser.profilePicturePreviewUrl
                "
                onlyPicture
                color="basic"
              ></nb-user>
              @if (!notification.read) {
              <span class="custom-badge user-badge"></span>
              }
            </span>
            } @case (eNotificationType.MODIFIED_COURSE_ROLE) {
            <span class="subtitle-2 has-custom-badge">
              <nb-user
                shape="rectangle"
                [name]="
                  notificationService.toAddedToCourseNotification(notification)
                    .creatorUser.fullName
                "
                [picture]="
                  notificationService.toAddedToCourseNotification(notification)
                    .creatorUser.profilePicturePreviewUrl
                "
                onlyPicture
                color="basic"
              ></nb-user>
              @if (!notification.read) {
              <span class="custom-badge user-badge"></span>
              }
            </span>
            } @case (eNotificationType.REVIEW_APPROVED) {
            <span class="subtitle-2 has-custom-badge">
              <nb-user
                shape="rectangle"
                [name]="
                  notificationService.toReviewNotification(notification).review
                    .reviewer.name
                "
                [picture]="
                  notificationService.toReviewNotification(notification).review
                    .reviewer.profilePicturePreviewUrl
                "
                onlyPicture
                color="basic"
              ></nb-user>
              @if (!notification.read) {
              <span class="custom-badge user-badge"></span>
              }
            </span>
            } @case (eNotificationType.REVIEW_DECLINED) {
            <span class="subtitle-2 has-custom-badge">
              <nb-user
                shape="rectangle"
                [name]="
                  notificationService.toReviewNotification(notification).review
                    .reviewer.name
                "
                [picture]="
                  notificationService.toReviewNotification(notification).review
                    .reviewer.profilePicturePreviewUrl
                "
                onlyPicture
                color="basic"
              ></nb-user>
              @if (!notification.read) {
              <span class="custom-badge user-badge"></span>
              }
            </span>
            } @case (eNotificationType.REVIEW_CHANGES_REQUESTED) {
            <span class="subtitle-2 has-custom-badge">
              <nb-user
                shape="rectangle"
                [name]="
                  notificationService.toReviewNotification(notification).review
                    .reviewer.name
                "
                [picture]="
                  notificationService.toReviewNotification(notification).review
                    .reviewer.profilePicturePreviewUrl
                "
                onlyPicture
                color="basic"
              ></nb-user>
              @if (!notification.read) {
              <span class="custom-badge user-badge"></span>
              }
            </span>
            } @case (eNotificationType.REVIEW_RE_REQUESTED) {
            <span class="subtitle-2 has-custom-badge">
              <nb-user
                shape="rectangle"
                [name]="
                  notificationService.toReviewNotification(notification).review
                    .receiver.name
                "
                [picture]="
                  notificationService.toReviewNotification(notification).review
                    .receiver.profilePicturePreviewUrl
                "
                onlyPicture
                color="basic"
              ></nb-user>
              @if (!notification.read) {
              <span class="custom-badge user-badge"></span>
              }
            </span>
            } @case (eNotificationType.REVIEW_ACKNOWLEDGED) {
            <span class="subtitle-2 has-custom-badge">
              <nb-user
                shape="rectangle"
                [name]="
                  notificationService.toReviewNotification(notification).review
                    .receiver.name
                "
                [picture]="
                  notificationService.toReviewNotification(notification).review
                    .receiver.profilePicturePreviewUrl
                "
                onlyPicture
                color="basic"
              ></nb-user>
              @if (!notification.read) {
              <span class="custom-badge user-badge"></span>
              }
            </span>
            } @case (eNotificationType.TASK_DEADLINE) {
            <span class="subtitle-2 has-custom-badge">
              <button nbButton status="basic">
                <nb-icon icon="alert-triangle-outline"></nb-icon>
              </button>
              @if (!notification.read) {
              <div class="custom-badge"></div>
              }
            </span>
            } @case (eNotificationType.EVENT_UPCOMING) {
            <span class="subtitle-2 has-custom-badge">
              <button nbButton status="basic">
                <nb-icon icon="people-outline"></nb-icon>
              </button>
              @if (!notification.read) {
              <div class="custom-badge"></div>
              }
            </span>
            } @case (eNotificationType.APPLICATION_REVIEW_ASSIGNED) {
            <span class="subtitle-2 has-custom-badge">
              <nb-user
                shape="rectangle"
                [name]="
                  notificationService.toApplicationReviewNotification(
                    notification
                  ).creatorUser.fullName
                "
                [picture]="
                  notificationService.toApplicationReviewNotification(
                    notification
                  ).creatorUser.profilePicturePreviewUrl
                "
                onlyPicture
                color="basic"
              ></nb-user>
              @if (!notification.read) {
              <span class="custom-badge user-badge"></span>
              }
            </span>
            } @case (eNotificationType.PERSON_ASSIGNED) {
            <span class="subtitle-2 has-custom-badge">
              <nb-user
                shape="rectangle"
                [name]="
                  notificationService.toPersonAssignedNotification(notification)
                    .creatorUser.fullName
                "
                [picture]="
                  notificationService.toPersonAssignedNotification(notification)
                    .creatorUser.profilePicturePreviewUrl
                "
                onlyPicture
                color="basic"
              ></nb-user>
              @if (!notification.read) {
              <span class="custom-badge user-badge"></span>
              }
            </span>
            } @case (eNotificationType.REGISTRATION_STATE_UPDATE) {
            <span class="subtitle-2 has-custom-badge">
              <button nbButton status="basic">
                <nb-icon icon="layers-outline"></nb-icon>
              </button>
              @if (!notification.read) {
              <div class="custom-badge"></div>
              }
            </span>
            } }
          </div>
          <div class="col-10">
            <div class="row">
              <div class="col-8">
                @switch (notification.type) { @case
                (eNotificationType.TASK_RELEASED) {
                <span class="subtitle-2">
                  {{
                    notificationService.toTaskReleasedNotification(notification)
                      .creatorChapter.title
                  }}
                </span>
                } @case (eNotificationType.CHAPTER_RELEASED) {
                <span class="subtitle-2">
                  {{
                    notificationService.toChapterReleasedNotification(
                      notification
                    ).creatorCourse.name
                  }}
                </span>
                } @case (eNotificationType.TEAM_INVITATION_RECEIVED) {
                <span class="subtitle-2">
                  {{
                    notificationService.toTeamInvitationReceivedNotification(
                      notification
                    ).creatorUser.fullName
                  }}
                </span>
                } @case (eNotificationType.ADDED_TO_COURSE) {
                <span class="subtitle-2">
                  {{
                    notificationService.toAddedToCourseNotification(
                      notification
                    ).creatorUser.fullName
                  }}
                </span>
                } @case (eNotificationType.MODIFIED_COURSE_ROLE) {
                <span class="subtitle-2">
                  {{
                    notificationService.toAddedToCourseNotification(
                      notification
                    ).creatorUser.fullName
                  }}
                </span>
                } @case (eNotificationType.REVIEW_APPROVED) {
                <span class="subtitle-2">
                  {{
                    notificationService.toReviewNotification(notification)
                      .review.reviewer.name
                  }}
                </span>
                } @case (eNotificationType.REVIEW_DECLINED) {
                <span class="subtitle-2">
                  {{
                    notificationService.toReviewNotification(notification)
                      .review.reviewer.name
                  }}
                </span>
                } @case (eNotificationType.REVIEW_CHANGES_REQUESTED) {
                <span class="subtitle-2">
                  {{
                    notificationService.toReviewNotification(notification)
                      .review.reviewer.name
                  }}
                </span>
                } @case (eNotificationType.REVIEW_RE_REQUESTED) {
                <span class="subtitle-2">
                  {{
                    notificationService.toReviewNotification(notification)
                      .review.receiver.name
                  }}
                </span>
                } @case (eNotificationType.REVIEW_ACKNOWLEDGED) {
                <span class="subtitle-2">
                  {{
                    notificationService.toReviewNotification(notification)
                      .review.receiver.name
                  }}
                </span>
                } @case (eNotificationType.TASK_DEADLINE) {
                <span class="subtitle-2">
                  {{
                    notificationService.toTaskReleasedNotification(notification)
                      .task.title
                  }}
                </span>
                } @case (eNotificationType.EVENT_UPCOMING) {
                <span class="subtitle-2">
                  {{
                    notificationService.toEventUpcomingNotification(
                      notification
                    ).task.title
                  }}
                </span>
                } @case (eNotificationType.APPLICATION_REVIEW_ASSIGNED) {
                <span class="subtitle-2">
                  {{
                    notificationService.toApplicationReviewNotification(
                      notification
                    ).creatorUser.fullName
                  }}
                </span>
                } @case (eNotificationType.PERSON_ASSIGNED) {
                <span class="subtitle-2">
                  {{
                    notificationService.toPersonAssignedNotification(
                      notification
                    ).creatorUser.fullName
                  }}
                </span>
                } @case (eNotificationType.REGISTRATION_STATE_UPDATE) {
                <span class="subtitle-2">
                  {{
                    notificationService.toRegistrationUpdatedStateNotification(
                      notification
                    ).registrationProcessName
                  }}
                </span>
                } }
              </div>
              <div class="col-4">
                <span class="text-hint subtitle-2 float-right">{{
                  notification.createdAt | relativeTime
                }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 my-auto">
                @switch (notification.type) { @case
                (eNotificationType.TASK_RELEASED) {
                <span class="paragraph">
                  <span translate="notification.released"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toTaskReleasedNotification(
                        notification
                      ).task.title
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.CHAPTER_RELEASED) {
                <span class="paragraph">
                  <span translate="notification.released"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toChapterReleasedNotification(
                        notification
                      ).chapter.title
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.TEAM_INVITATION_RECEIVED) {
                <span class="paragraph">
                  <span translate="notification.invitedToTeam"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toTeamInvitationReceivedNotification(
                        notification
                      ).invitationFrom.name
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.ADDED_TO_COURSE) {
                <span class="paragraph">
                  <span translate="notification.addedTo"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toAddedToCourseNotification(
                        notification
                      ).course.name
                    }}
                  </strong>
                  <span translate="notification.asRole"></span>
                  <strong
                    class="highlight-text"
                    [translate]="
                      'roles.' +
                      notificationService.toAddedToCourseNotification(
                        notification
                      ).accessLevel
                    "
                  >
                  </strong>
                </span>
                } @case (eNotificationType.MODIFIED_COURSE_ROLE) {
                <span class="paragraph">
                  <span translate="notification.changedTo"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toAddedToCourseNotification(
                        notification
                      ).course.name
                    }}
                  </strong>
                  <span translate="notification.to"></span>
                  <strong
                    class="highlight-text"
                    [translate]="
                      'roles.' +
                      notificationService.toAddedToCourseNotification(
                        notification
                      ).accessLevel
                    "
                  >
                  </strong>
                </span>
                } @case (eNotificationType.REVIEW_APPROVED) {
                <span class="paragraph">
                  <span translate="notification.review.approved"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toReviewNotification(notification)
                        .review.submission.task.title
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.REVIEW_DECLINED) {
                <span class="paragraph">
                  <span translate="notification.review.declined"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toReviewNotification(notification)
                        .review.submission.task.title
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.REVIEW_CHANGES_REQUESTED) {
                <span class="paragraph">
                  <span translate="notification.review.changesRequested"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toReviewNotification(notification)
                        .review.submission.task.title
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.REVIEW_RE_REQUESTED) {
                <span class="paragraph">
                  <span translate="notification.review.reRequested"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toReviewNotification(notification)
                        .review.submission.task.title
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.REVIEW_ACKNOWLEDGED) {
                <span class="paragraph">
                  <span translate="notification.review.acknowledged"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toReviewNotification(notification)
                        .review.submission.task.title
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.TASK_DEADLINE) {
                <span class="paragraph">
                  <span translate="notification.deadline"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toTaskDeadlineNotification(
                        notification
                      ).task.endDate | date : "short"
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.EVENT_UPCOMING) {
                <span class="paragraph">
                  <span translate="notification.event"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toEventUpcomingNotificationEvent(
                        notification
                      ).eventDate | date : "short"
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.APPLICATION_REVIEW_ASSIGNED) {
                <span class="paragraph">
                  <span
                    translate="notification.assignedApplicationReview"
                  ></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toApplicationReviewNotification(
                        notification
                      ).applicationReview.applicationRoundResult.applicant.name
                    }}
                  </strong>
                  <span translate="notification.in"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toApplicationReviewNotification(
                        notification
                      ).applicationReview.applicationRoundResult.applicant
                        .applicationProcess.name
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.PERSON_ASSIGNED) {
                <span class="paragraph">
                  <span translate="notification.offeredToClaim"></span>
                  <strong class="highlight-text">
                    {{
                      notificationService.toPersonAssignedNotification(
                        notification
                      ).person.fullName
                    }}
                  </strong>
                </span>
                } @case (eNotificationType.REGISTRATION_STATE_UPDATE) {
                <span class="paragraph">
                  <span
                    translate="notification.registrationStateUpdated"
                  ></span>
                  <strong class="highlight-text">
                    {{
                      "registration.state." +
                        notificationService.toRegistrationUpdatedStateNotification(
                          notification
                        ).registrationState | translate
                    }}
                  </strong>
                </span>
                } }
              </div>
            </div>
          </div>
        </div>
      </nb-list-item>
      }
    </nb-list>
    }
    <!-- TODO: Make this look nice -->
    <div
      (click)="includeReadNotifications = true; loadNotifications()"
      [hidden]="includeReadNotifications"
      class="subtitle text-hint load-indicator"
    >
      <span translate="notification.showReadNotifications"></span>
      <nb-icon icon="arrow-ios-downward-outline"></nb-icon>
    </div>
    @for (_ of placeholders; track _) {
    <nb-list-item>
      <div class="row w-100">
        <div class="col-12 text my-auto">
          <div class="placeholder-notification"></div>
        </div>
      </div>
    </nb-list-item>
    }
  </nb-card-body>
</nb-card>
